import Vue from 'vue'
import Vuex from 'vuex'
import { setToken, getToken, remToken } from './token'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: getToken() || {},
    loginShow: false, // 控制登录弹框
  },
  getters: {},
  mutations: {
    setTokenInfo(state, newSetToken) {
      state.userInfo = newSetToken
      setToken(newSetToken)
    },
    setLoginShow(state, newLoginShow) {
      state.loginShow = newLoginShow
    },
    remTokenInfo(state) {
      state.userInfo = {}
      remToken()
    },
  },
  actions: {},
  modules: {},
})
